import '@angular/common/locales/global/nl-BE'
import {Component, Input, OnDestroy, OnInit} from '@angular/core'
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { IUser, ISchool, ISchoolClass } from "redwood-model/dist"
import {REDWOOD_USER} from "../shared-worker-on-ui-thread";
import {PARAMS} from "../PARAMS";
import {getCurrentAmplifyUser, getSession} from "../amplify/amplify";
import {graphqlRequest} from "../graphqlHelper";
import {showToast} from "../../toast";
import {logout} from "../logout/logout";
import {Auth} from "aws-amplify";
import {logError} from "../../log";
import {executeCaptchaAction, setCaptchaV3Service} from "../captcha";
import {hideSpinner, showSpinner} from "../../spinner";
import { AuthenticatorService } from '@aws-amplify/ui-angular';
import { reInitAmplify } from 'src/utils';
import {ReCaptchaV3Service} from "ng-recaptcha";
import {isValidRegimentalNumber} from "../validators";
import {GoingBackService} from "../GoingBackService";

interface IschoolBasic { name: string, id: number, school_roles: { role: string, recordId: number }[] }
interface IclassBasic { name: string, id: number | undefined }
interface IPostalcode {
  zip: string,
  city: string,
  combined?: string
}
interface ICountry {
  name: string,
  code: string
}
const role_map: any =
  {
    "Leerling": "ROLE_STUDENT",
    'Leerkracht': "ROLE_TEACHER",
    "School admin": "ROLE_ADMIN",
    "Secretariaat": "ROLE_OFFICE",
  }

@Component({
  selector: 'app-link-school',
  templateUrl: './link-school.component.html',
  styleUrls: ['./link-school.component.scss']
})
export class LinkSchoolComponent implements OnInit, OnDestroy {
  schoolForm: FormGroup | undefined

  newSchoolForm: FormGroup | undefined
  user: IUser | undefined = undefined
  selectedRole = 'ROLE_STUDENT'
  schoolsLoading = false
  schoolError: any = null
  selectedSchool: IschoolBasic | undefined = undefined
  schoolData: IschoolBasic[] = []
  initialSchool: IschoolBasic | undefined
  selectedClassId: number | undefined = undefined
  unselectedClass: IclassBasic = { id: undefined, name: 'selecteer een klas'}
  classOptions: IclassBasic[] = []
  classLoading = false
  classError: any = null
  amplify_user: any
  currentSchools: IschoolBasic[] = []
  canAddSchool = false
  addingSchool = false
  initialPostal: IPostalcode | undefined
  postalData: IPostalcode[] = []
  postalCodes: IPostalcode[] = []
  selectedPostalCode: IPostalcode | undefined
  countries: ICountry[] = []
  selectedCountry = "BE"


  constructor(
    private formBuilder: FormBuilder,
    private authenticator: AuthenticatorService,
    private recaptchaV3Service: ReCaptchaV3Service
  ) {
    setCaptchaV3Service(recaptchaV3Service)
  }

  ngOnDestroy() {
  }

  async ngOnInit() {

    try {
      showSpinner('We laden de benodigde gegevens.')

      const postalRequest = await fetch('/assets/postalcodes.json')
      const postalData = await postalRequest.json()
      this.postalCodes = postalData.map((pData: {zip: string, city: string, combined: string}) => {
        pData["combined"] = `${pData.zip} ${pData.city}`
        return pData
      })
      const countryRequest = await fetch('/assets/countries.json')
      this.countries = await countryRequest.json()

      this.schoolForm = this.formBuilder.group({
        stamboek: [undefined],
        school: [undefined],
        klas: [undefined],
        school_role: [undefined, Validators.required]
      })

      this.newSchoolForm = this.formBuilder.group({
        school_nr: [undefined],
        name: [undefined, Validators.required],
        address: [undefined, Validators.required],
        postal: [undefined],
        country: [undefined, Validators.required],
        email: [undefined, Validators.required],
        phone: [undefined, Validators.required],
        website: [undefined],
      })

      this.currentSchools = await this.fetchSchoolQuery()
      if (!this.currentSchools.length) this.canAddSchool = true;

      hideSpinner();


    } catch (err) {
      logError(err)
    }
  }

  async onSubmit(event: SubmitEvent) {
    event.preventDefault()
    const redwood_user = REDWOOD_USER();
    const { selectedRole, selectedSchool, schoolForm } = this;
    const formValues = schoolForm?.value ?? {};

    if (['ROLE_ADMIN', 'ROLE_OFFICE'].includes(selectedRole)) {
      formValues['klas'] = undefined;
      formValues['stamboek'] = undefined;
    }
    if (selectedRole === 'ROLE_STUDENT') {
      formValues['stamboek'] = undefined;
    }

    const token = this.amplify_user?.signInUserSession?.accessToken?.jwtToken || (await getSession()).access_token

    if (!this.isValid) return;
    if (!token) throw new Error('User not authenticated')


    const query = `
      mutation {
          linkUserToSchoolRole(
              input: {
                  user_id: ${+(redwood_user.id)}
                  school_role: "${selectedRole}"
                  school_id: ${+('' + selectedSchool?.id)}
                  ${formValues['klas'] ? `class_id: ${+(formValues['klas'])}` : ''}
                  ${formValues['stamboek'] ? `regimentalNumber: "${formValues['stamboek']}"` : ''}
              }
          ){
              school_user_id
          }
      }`
    const {data, errors} = await graphqlRequest({url: PARAMS["REDWOOD-LAMBDA"] + '/query', query, token})

    if (errors.length) {
      showToast(errors[0].message, 'error')
      throw new Error(errors.map((err: any) => err.message).join(', '))
    }

    if (!errors.length) {
      showToast(`Gebruiker werdt aan: ${selectedSchool?.name} gelinkt!`, 'success')

      //continue to redwood
      this.currentSchools = await this.fetchSchoolQuery()
      this.cancel()
    }



  }
  async onSubmitSchool(event: SubmitEvent) {
    event.preventDefault()

    try {
      if (this.isAddSchoolValid || !this.selectedPostalCode) throw new Error('form not valid')

      const redwoodUser = REDWOOD_USER()
      const { name, phone, address, country, email, website, school_nr } = this.newSchoolForm?.value
      const { zip: postal, city} = this.selectedPostalCode

      const token = this.amplify_user?.signInUserSession?.accessToken?.jwtToken || (await getSession()).access_token

      if (!token) throw new Error('User not authenticated')
      const captcha = await executeCaptchaAction('NewSchoolRequest')

      const query = `
      mutation {
          newSchoolRequest(
              input: {
                  name: "${name}"
                  phone: "${phone}"
                  address: "${address}"
                  country: "${country}"
                  email: "${email}"
                  ${school_nr ? `school_nr: "${school_nr}"` : ''}
                  postal: "${postal}"
                  city: "${city}"
                  request_by_email: "${redwoodUser.email}"
                  captcha: "${captcha}"
                  ${website ? `website: "${website}"` : ''}
              }
          )
      }`
      const {data, errors} = await graphqlRequest({url: PARAMS["REDWOOD-LAMBDA"] + '/query', query, token})

      if (errors.length) {
        showToast(errors[0].message, 'error')
        throw new Error(errors.map((err: any) => err.message).join(', '))
      }


      if (!errors.length) {
        showToast(`Uw verzoek om school: ${name} toe te voegen werd verzonden!`, 'success')

        if (!this.currentSchools?.length) {
          setTimeout(async () => {
            alert('U wordt nu uitgelogd. Log alstublieft opnieuw in zodra u feedback ontvangt over uw nieuwe schoolaanvraag.')
            await Auth.signOut()
            reInitAmplify()
          },1000)
          return
        }
        this.addingSchool = false
        this.canAddSchool = false

      }
    } catch (err) {
      logError(err)
    }
  }
  async fetchSchoolQuery (): Promise<IschoolBasic[]> {
    const redwoodUser = REDWOOD_USER()
    const token = this.amplify_user?.signInUserSession?.accessToken?.jwtToken || (await getSession()).access_token
    let schoolsArray: IschoolBasic[] = []
    if (!token) throw new Error('user not authenticated')
    try {
      this.schoolsLoading = true;
      const query = `
      query userByIdQuery($id: Int!) {
            userByIdQuery(id: $id) {
                schoolUsers {
                    school_role
                    id
                    school {
                        id
                        name,

                    }
                }
            }
        }`
      const variables = { id: Number(redwoodUser.id) };

      const operationName = 'userByIdQuery'

      const {data, errors} = await graphqlRequest( {
        url: PARAMS["REDWOOD-LAMBDA"]+'/query',
        query,
        operationName,
        token,
        variables
      })

      if (errors.length) {
        throw new Error(errors.map((err: any) => err.message).join(', '));
      }

      const schoolUsers = data?.data?.userByIdQuery?.schoolUsers;

      for (const { school: serverSchool, school_role: role, id } of schoolUsers) {
        let knownSchool = schoolsArray.find(s => s.id === serverSchool.id);

        if (knownSchool) {
          if (!knownSchool.school_roles.find(r => r.role === role)) {
            knownSchool.school_roles.push({role, recordId: id});
          }
        } else {
          schoolsArray.push({
            ...serverSchool,
            school_roles: [{role, recordId: id}]
          });
        }
      }


    } catch (err) {
      this.schoolError = err

    } finally {
      this.schoolsLoading = false;

      return schoolsArray

    }
  }
  async selectSchool($event: IschoolBasic) {
    this.selectedSchool = $event
    const options = await this.fetchClassQuery();
    this.classOptions = [this.unselectedClass, ...options]
  }
  async searchSchools($event: string) {
    this.initialSchool = undefined
    this.schoolData = await this.fetchSchoolSearch($event)
  }
  async fetchSchoolSearch(input: string) : Promise<IschoolBasic[]> {

    let schoolsArray: IschoolBasic[] = []

    if (input.length < 1) return schoolsArray

    try {
      const token = this.amplify_user?.signInUserSession?.accessToken?.jwtToken || (await getSession()).access_token

      if (!token) throw new Error('user not authenticated')
      this.schoolsLoading = true;
      const query = `
      query schoolsQuery($prefix: String!) {
            schoolsQuery(prefix: $prefix) {
                id
                name
            }
        }`
      const variables = { prefix: String(input) };

      const operationName = 'schoolsQuery'

      const {data, errors} = await graphqlRequest({
        url: PARAMS["REDWOOD-LAMBDA"] + '/query',
        query,
        operationName,
        token,
        variables
      })

      if (errors.length) {
        throw new Error(errors.map((err: any) => err.message).join(', '));
      }
      schoolsArray = data?.data?.schoolsQuery
        ?.filter((school: IschoolBasic, index: number, self: []) =>
          index === self.findIndex((s: IschoolBasic) => s.id === school.id)
        );
    } catch (err) {
      logError(err)
    } finally {
      return schoolsArray
    }
  }
  clearClasses() {
    this.classOptions = [this.unselectedClass]
    this.selectedClassId = undefined
  }
  selectedSchoolRender(school: IschoolBasic) : string {
    return school.name
  }
  getRoleName(input:string): string {
    const key = Object.entries(role_map).find(([key, value]) => value === input)?.[0];

    if (key) return key
    return input

  }
  async fetchClassQuery (): Promise<IclassBasic[]> {
    let classArray: IclassBasic[] = []
    try {

      if (!this.selectedSchool?.id) throw new Error('No school selected')

      const token = this.amplify_user?.signInUserSession?.accessToken?.jwtToken || (await getSession()).access_token

      if (!token) throw new Error('User not authenticated')

      this.classLoading = true;
      const query = `
      query classesForSchoolQuery($school_id: Int!) {
            classesForSchoolQuery(school_id: $school_id) {
                id
                name
            }
        }`
      const variables = { school_id: Number(this.selectedSchool?.id) };

      const operationName = 'classesForSchoolQuery'

      const {data, errors} = await graphqlRequest({
        url: PARAMS["REDWOOD-LAMBDA"] + '/query',
        query,
        operationName,
        token,
        variables
      })

      if (errors.length) {
        throw new Error(errors.map((err: any) => err.message).join(', '));
      }
      classArray = data?.data?.classesForSchoolQuery
        ?.filter((klas: IclassBasic, index: number, self: []) =>
          index === self.findIndex((c: IclassBasic) => c.id === klas.id)
        );

    } catch (err) {
      this.classError = err

    } finally {
      this.classLoading = false;

      return classArray

    }
  }
  get isAddSchoolValid(): boolean {
    const formValid = this.newSchoolForm?.valid;

    const result = !(formValid && this.selectedPostalCode?.zip)


    return result
  }

  get isValid(): boolean {
    const { selectedRole, selectedSchool, schoolForm } = this;
    const formValues = schoolForm?.value ?? {};

    if (['ROLE_ADMIN', 'ROLE_OFFICE'].includes(selectedRole)) {
      return !!selectedSchool?.id;
    }

    if (selectedRole === 'ROLE_TEACHER') {
      return !!(selectedSchool && isValidRegimentalNumber(formValues['stamboek']) && formValues['klas']);
    }

    if (selectedRole === 'ROLE_STUDENT') {
      return !!(selectedSchool && formValues['klas']);
    }

    return false;
  }

  get hasClass(): boolean {
    return ['ROLE_TEACHER', 'ROLE_STUDENT'].indexOf(this.selectedRole) !== -1
  }
  get isTeacher(): boolean {
    return ['ROLE_TEACHER'].indexOf(this.selectedRole) !== -1
  }

  async unlinkSchool(school: IschoolBasic, role:string) {
    try {
      if (!confirm('Bent u zeker dat u de gebruikersrol wenst te ontkoppelen?')) return
      const redwood_user = REDWOOD_USER();
      const token = this.amplify_user?.signInUserSession?.accessToken?.jwtToken || (await getSession()).access_token

      if (!token) throw new Error('User not authenticated')


      const query = `
      mutation {
          unlinkUserToSchoolRole(
              input: {
                  user_id: ${+(redwood_user.id)}
                  school_role: "${role}"
                  school_id: ${+('' + school?.id)}
              }
          )
      }`
      const {data, errors} = await graphqlRequest({url: PARAMS["REDWOOD-LAMBDA"] + '/query', query, token})

      if (errors.length) {
        showToast(errors[0].message, 'error')
        throw new Error(errors.map((err: any) => err.message).join(', '))
      }


      if (!errors.length) {
        showToast(`${this.getRoleName(role)} werd van ${school?.name} ontkoppeld!`, 'success')

        this.currentSchools = await this.fetchSchoolQuery()
        this.cancel()

      }
    } catch (err) {

    }

  }

  cancel() {
    this.canAddSchool = false;
  }
  back() {
    const needsActivation = +(sessionStorage.getItem('needsActivation') || '0');
    if (needsActivation && this.currentSchools.length) {
      sessionStorage.removeItem('needsActivation');
      const url = PARAMS["REDWOOD_UI"] + '/login';
      location.replace(url)

      return
    }
    GoingBackService.handleBack()
  }
  selectPostalcode($event: IPostalcode) {
      this.selectedPostalCode = $event
    }

    searchPostalCode($event: string) {
      this.initialPostal = undefined
      this.postalData = [...this.postalCodes.filter(pc => pc.zip.startsWith($event))]
    }
    selectedPostalRender(pc: any) : string {
      return `${pc.zip} - ${pc.city}`
    }


  protected readonly role_map = role_map;
  protected readonly Object = Object;
}

